import { render, staticRenderFns } from "./MonitorControl.vue?vue&type=template&id=2ba9bd6a&"
import script from "./MonitorControl.vue?vue&type=script&lang=js&"
export * from "./MonitorControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports